import './index.less';
import React, { Component } from 'react';
import { Button } from '@beehive/components';
import { History, Location } from 'history';
import PropTypes from 'prop-types';
import messages from 'messages/CompanyManagement';

export interface HeaderProps {
  history: History;
  location: Location;
  permitButtons?: any;
  readOnly?: boolean;
}

class Header extends Component<HeaderProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };

  private handleClickEdit = () => {
    const { history, location } = this.props;
    history.push({ ...location, pathname: `${location.pathname}/edit` });
  }

  public render() {
    const { intl } = this.context;
    const { permitButtons = {}, readOnly = true } = this.props;
    const { edit_btn = false } = permitButtons;

    if (readOnly || !edit_btn) {
      return null;
    }

    return (
      <div className="mpc-ext-company-info-detail-header">
        <Button
          className="pull-right"
          type="primary"
          size="large"
          onClick={this.handleClickEdit}
        >
          {intl.formatMessage(messages.edit)}
        </Button>
      </div>
    );
  }
}

export default Header;
